import { render, staticRenderFns } from "./radio-ui-right.mpx?vue&type=template&id=048e1cb4&isComponent&outputPath=components%2Fradio-ui-right3fc27b28%2Findex"
import script from "./radio-ui-right.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fradio-ui-right3fc27b28%2Findex"
export * from "./radio-ui-right.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fradio-ui-right3fc27b28%2Findex"
import style0 from "./radio-ui-right.mpx?vue&type=style&index=0&id=048e1cb4&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_3fc27b28%22%7D&isComponent&outputPath=components%2Fradio-ui-right3fc27b28%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports